import moment from 'moment';

const clients_table_columns = [
  {
    label: 'CLIENTS.USER_ID',
    value: 'user_id',
    property: 'User ID',
  },
  {
    label: 'CLIENTS.EMAIL',
    value: 'email',
    property: 'Email',
  },
  {
    label: 'CLIENTS.ACCOUNT_STATUS',
    value: 'status',
    property: 'Account Status',
  },
  {
    label: 'CLIENTS.ACHIEVEMENT_STATUS',
    value: 'user_level',
    property: 'Achievement Status',
  },
  {
    label: 'CLIENTS.DEPOSITED_SUM',
    value: 'deposited_sum',
    prefix: '$',
    is_number: true,
    property: 'Deposits',
  },
  {
    label: 'CLIENTS.WITHDRAWAL_SUM',
    value: 'withdrawn_sum',
    prefix: '$',
    is_number: true,
    property: 'Withdrawals',
  },
  {
    label: 'CLIENTS.DEPOSITED_SUM_NET',
    value: 'net_deposit_sum',
    prefix: '$',
    is_number: true,
    property: 'Net Deposits',
  },
  {
    label: 'CLIENTS.TOTAL_TRADES',
    value: 'trades_made',
    is_number: true,
    property: 'Total Trades',
  },
  {
    label: 'CLIENTS.QUALIFIED_TRADES',
    value: 'valid_trades_made',
    is_number: true,
    property: 'Total Trades',
  },
  {
    label: 'CLIENTS.LOTS_TRADED',
    value: 'volume_traded',
    prefix: '$',
    is_number: true,
    property: 'Total Volume',
  },
  {
    label: 'CLIENTS.QUALIFIED_LOTS',
    value: 'valid_volume_traded',
    prefix: '$',
    is_number: true,
    property: 'Qualified Volume',
  },
  {
    label: 'CLIENTS.COMMISSION_ACHIEVEMENTS',
    value: 'commission_earned_achievement',
    prefix: '$',
    is_number: true,
    property: 'Commission Achievements',
  },
  {
    label: 'CLIENTS.COMMISSION_TRADING',
    value: 'commission_earned_trading',
    prefix: '$',
    is_number: true,
    property: 'Commission Trading',
  },
  {
    label: 'CLIENTS.COMMISSION',
    value: 'commission_sum',
    prefix: '$',
    is_number: true,
    property: 'Commission',
  },
  {
    label: 'CLIENTS.PENDING_COMMISSION',
    value: 'commission_pending',
    prefix: '$',
    is_number: true,
    property: 'Pending Commission',
  },
  {
    label: 'CAMPAIGNS.ACTION',
  },
];

const ib_ifs_user_hidden_labels = ['CLIENTS.COMMISSION_ACHIEVEMENTS', 'CLIENTS.COMMISSION_TRADING', 'CLIENTS.PENDING_COMMISSION'];

const mapped_clients_keys = {
  user_id: 'Referred User ID',
  email: 'Email',
  status: 'Account Status',
  user_level: 'Achievements Status',
  deposited_sum: 'Deposits',
  withdrawn_sum: 'Withdrawals',
  net_deposit_sum: 'Net Deposits',
  trades_made: 'Total Trades',
  valid_trades_made: 'Qualified Trades',
  volume_traded: 'Total Volume',
  valid_volume_traded: 'Qualified Volume',
  commission_earned_achievement: 'Commission Achievements',
  commission_earned_trading: 'Commission Trading',
  commission_sum: 'Total Commission',
  commission_pending: 'Pending Commission',
};

const hidden_columns = {
  first_name: 'first_name',
  last_name: 'last_name',
  phone_number: 'phone_number',
};

const export_buttons = {
  csv: {
    label: 'EXPORT.CSV',
    type: 'csv',
    icon: 'glyphicon-download-alt',
  },
  xlsx: {
    label: 'EXPORT.XLSX',
    type: 'xlsx',
    icon: 'glyphicon-download-alt',
  },
  html: {
    label: 'EXPORT.HTML',
    type: 'html',
    icon: 'glyphicon-download-alt',
  },
  print: {
    label: 'EXPORT.PRINT',
    type: 'print',
    icon: 'glyphicon-print',
  },
};

const clients_file_name = `clients_list_${moment().format('DD_MM_YYYY_HH_mm')}`;
const tableToPrintClass = 'payment-history-table-container__table';

export default {
  clients_table_columns,
  ib_ifs_user_hidden_labels,
  mapped_clients_keys,
  hidden_columns,
  clients_file_name,
  export_buttons,
  tableToPrintClass,
};



// WEBPACK FOOTER //
// ./src/app/main/clients/constants/clients-constants.js